import BandeiraALE from "assets/icons/Alemanha.png";
import BandeiraANG from "assets/icons/ANG.png";
import BandeiraARG from "assets/icons/ARG.jpg";
import BandeiraBRA from "assets/icons/BRA.png";
import BandeiraCAN from "assets/icons/CAN.png";
import BandeiraBMU from "assets/icons/BMU.png";
import BandeiraBRB from "assets/icons/BRB.png";
import BandeiraDMA from "assets/icons/DMA.png";
import BandeiraDOM from "assets/icons/DOM.png";
import BandeiraGRD from "assets/icons/GRD.png";
import BandeiraJAM from "assets/icons/JAM.png";
import BandeiraCHI from "assets/icons/CHI.png";
import BandeiraCOL from "assets/icons/COL.png";
import BandeiraDUB from "assets/icons/DUB.png";
import BandeiraESP from "assets/icons/ESP.png";
import BandeiraEUA from "assets/icons/EUA.png";
import BandeiraFRA from "assets/icons/FRA.png";
import BandeiraIND from "assets/icons/IND.png";
import BandeiraGBR from "assets/icons/GBR.png";
import BandeiraIRL from "assets/icons/IRL.png";
import BandeiraMLT from "assets/icons/MLT.png";
import BandeiraITA from "assets/icons/ITA.png";
import BandeiraMEX from "assets/icons/MEX.png";
import BandeiraNLD from "assets/icons/NLD.png";
import BandeiraPAR from "assets/icons/PAR.png";
import BandeiraPER from "assets/icons/PER.png";
import BandeiraPOR from "assets/icons/POR.png";
import BandeiraURU from "assets/icons/URU.png";
import BandeiraPNG from "assets/icons/PNG.png";
import BandeiraSLB from "assets/icons/SLB.png";
import BandeiraFJI from "assets/icons/FJI.png";
import BandeiraBLZ from "assets/icons/BLZ.png";
import BandeiraCRI from "assets/icons/CRI.png";
import BandeiraPAN from "assets/icons/PAN.png";
import BandeiraVEN from "assets/icons/VEN.png";
import BandeiraAUS from "assets/icons/AUS.png";
import BandeiraPHL from "assets/icons/PHL.png";
import BandeiraNZL from "assets/icons/NZL.png";
import BandeiraCHN from "assets/icons/CHN.png";

export const ddis = [
	{
		prefix: "USA",
		ddi: "+1",
		img: BandeiraEUA,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: false,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "(XXX) XXX-XXXX",
			regex: /^\(\d{3}\)\s\d{3}-\d{4}$/,
			maxLength: 14,
		},
	},
	{
		prefix: "CAN",
		ddi: "+1",
		img: BandeiraCAN,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: false,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "(XXX) XXX-XXXX",
			regex: /^\(\d{3}\)\s\d{3}-\d{4}$/,
			maxLength: 14,
		},
	},
	{
		prefix: "DMA",
		ddi: "+1",
		img: BandeiraDMA,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 767,
		phonePositionNumberExtraPrefix: 0,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "GRD",
		ddi: "+1",
		img: BandeiraGRD,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 473,
		phonePositionNumberExtraPrefix: 0,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "MEX",
		ddi: "+52",
		img: BandeiraMEX,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "(XXX) XXX-XXXX",
			regex: /^\(\d{3}\)\s\d{3}-\d{4}$/,
			maxLength: 14,
		},
	},
	{
		prefix: "CUB",
		ddi: "+53",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^5\d{1}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "ARG",
		ddi: "+54",
		img: BandeiraARG,
		maxLength: 11,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "X (XX) XXXX-XXXX",  
			regex: /^[9]\s\(\d{2}\)\s\d{4}-\d{4}$/,  
			maxLength: 16,  
		},
	},
	{
		prefix: "ESP",
		ddi: "+34",
		img: BandeiraESP,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "FRA",
		ddi: "+33",
		img: BandeiraFRA,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "X XX XX XX XX",
			regex: /^(6|7)\s\d{2}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 14,
		},
	},
	{
		prefix: "NLD",
		ddi: "+31",
		img: BandeiraNLD,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^6\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "ITA",
		ddi: "+39",
		img: BandeiraITA,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^3\d{2}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "BRA",
		ddi: "+55",
		img: BandeiraBRA,
		maxLength: 11,
		phoneTypeAuthVerify: "sms",
		removePrefix: false,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "(XX) XXXXX-XXXX",
			regex: /^\(\d{2}\)\s9\d{4}-\d{4}$/,
			maxLength: 15,
		},
	},
	{
		prefix: "GHA",
		ddi: "+233",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "NGA",
		ddi: "+234",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "TCD",
		ddi: "+235",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "CAF",
		ddi: "+236",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "CMR",
		ddi: "+237",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "CPV",
		ddi: "+238",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^\d{3}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "STP",
		ddi: "+239",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^\d{3}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "GNQ",
		ddi: "+240",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "AIA",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 264,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "TCA",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 649,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "THA",
		ddi: "+66",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^[689]\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "MNP",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 670,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "KOR",
		ddi: "+82",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX-XXXX-XXXX",
			regex: /^1\d{1}-\d{4}-\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "VNM",
		ddi: "+84",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^[35789]\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "MSR",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 664,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "TUR",
		ddi: "+90",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^5\d{2}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "BMU",
		ddi: "+1",
		img: BandeiraBMU,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 441,
		phonePositionNumberExtraPrefix: 0,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "PAK",
		ddi: "+92",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "COM",
		ddi: "+269",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^\d{3}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "SHN",
		ddi: "+290",
		img: null,
		maxLength: 4,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX",
			regex: /^\d{4}$/,
			maxLength: 4,
		},
	},
	{
		prefix: "ERI",
		ddi: "+291",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^\d{3}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "ABW",
		ddi: "+297",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^\d{3}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "FRO",
		ddi: "+298",
		img: null,
		maxLength: 6,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX",
			regex: /^\d{3}\s\d{3}$/,
			maxLength: 7,
		},
	},
	{
		prefix: "GRL",
		ddi: "+299",
		img: null,
		maxLength: 6,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX",
			regex: /^\d{3}\s\d{3}$/,
			maxLength: 7,
		},
	},
	{
		prefix: "GIB",
		ddi: "+350",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "PRT",
		ddi: "+351",
		img: BandeiraPOR,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "HRV",
		ddi: "+385",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "SEN",
		ddi: "+221",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "MRT",
		ddi: "+222",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "MLI",
		ddi: "+223",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "GIN",
		ddi: "+224",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "CIV",
		ddi: "+225",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "BFA",
		ddi: "+226",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "NER",
		ddi: "+227",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "DMA",
		ddi: "+1",
		img: BandeiraDMA,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 767,
		phonePositionNumberExtraPrefix: 0,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "BEN",
		ddi: "+229",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "MUS",
		ddi: "+230",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^\d{3}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "BLZ",
		ddi: "+501",
		img: BandeiraBLZ,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX-XXXX",
			regex: /^\d{3}-\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "SLE",
		ddi: "+232",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "CHL",
		ddi: "+56",
		img: BandeiraCHI,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "X XXXX-XXXX",
			regex: /^\d{1}\s\d{4}-\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "DOM",
		ddi: "+1",
		img: BandeiraDOM,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\((809|829|849)\)\s\d{3}\s\d{4}$/,
			maxLength: 14,
		},
	},
	{
		prefix: "ALB",
		ddi: "+355",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^6\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "ARE",
		ddi: "+971",
		img: BandeiraDUB,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "(XX) XXX XXXX",
			regex: /^\(\d{2}\)\s\d{3}\s\d{4}$/,
			maxLength: 13,
		},
	},
	{
		prefix: "PRY",
		ddi: "+595",
		img: BandeiraPAR,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "X XXXX-XXXX",
			regex: /^\d{1}\s\d{4}-\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "SLB",
		ddi: "+677",
		img: BandeiraSLB,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^\d{4}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "URY",
		ddi: "+598",
		img: BandeiraURU,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "X XXX-XXXX",
			regex: /^\d{1}\s\d{3}-\d{4}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "JAM",
		ddi: "+1",
		img: BandeiraJAM,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 876,
		phonePositionNumberExtraPrefix: 0,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "FJI",
		ddi: "+679",
		img: BandeiraFJI,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^[789]\d{2}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "BRA",
		ddi: "+55",
		img: BandeiraBRA,
		maxLength: 11,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "(XX) XXXXX-XXXX",
			regex: /^\(\d{2}\)\s9\d{4}-\d{4}$/,
			maxLength: 15,
		},
	},
	{
		prefix: "DZA",
		ddi: "+213",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "X XX XX XX XX",
			regex: /^(5|6|7)\s\d{2}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 13,
		},
	},
	{
		prefix: "AGO",
		ddi: "+244",
		img: BandeiraANG,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "CRI",
		ddi: "+506",
		img: BandeiraCRI,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX-XXXX",
			regex: /^\d{4}-\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "VEN",
		ddi: "+58",
		img: BandeiraVEN,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 13,
		},
	},
	{
		prefix: "AND",
		ddi: "+376",
		img: null,
		maxLength: 6,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX",
			regex: /^3\d{1}\s\d{2}\s\d{2}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "BWA",
		ddi: "+267",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^7\d{1}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "AUT",
		ddi: "+43",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^6\d{2}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "VGB",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 284,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "BEL",
		ddi: "+32",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XX XX XX",
			regex: /^4\d{2}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 13,
		},
	},
	{
		prefix: "CYP",
		ddi: "+357",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXXXXX",
			regex: /^9\d{1}\s\d{6}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "HRV",
		ddi: "+385",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^9\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "CYM",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 345,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "CCK",
		ddi: "+61",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "COK",
		ddi: "+682",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "ASM",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 684,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "BEN",
		ddi: "+229",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX XX",
			regex: /^\d{2}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "BFA",
		ddi: "+226",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX XX",
			regex: /^7\d{1}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "COG",
		ddi: "+242",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "ATG",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 268,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "CMR",
		ddi: "+237",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "X XX XX XX XX",
			regex: /^6\s\d{2}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 13,
		},
	},
	{
		prefix: "TCD",
		ddi: "+235",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX XX",
			regex: /^6\d{1}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "CAF",
		ddi: "+236",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXXX",
			regex: /^7\d{2}\s\d{5}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "BTN",
		ddi: "+975",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^17\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "ATA",
		ddi: "+672",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "ABW",
		ddi: "+297",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^(56|59|73|74|99)\d{1}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "AZE",
		ddi: "+994",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^(4[0-9]|5[0-5]|6[0-5]|7[0-7])\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "BIH",
		ddi: "+387",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^6\d{1}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "BDI",
		ddi: "+257",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX XX",
			regex: /^7\d{1}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "BGR",
		ddi: "+359",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^88\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "BOL",
		ddi: "+591",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXX",
			regex: /^7\d{7}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "CUB",
		ddi: "+53",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^5\d{1}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "BHR",
		ddi: "+973",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^((3|66|322)[0-9]{1,2})\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "BRN",
		ddi: "+673",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^\d{3}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "BLR",
		ddi: "+375",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX-XX-XX",
			regex: /^(25|29|33|44)\s\d{3}-\d{2}-\d{2}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "KHM",
		ddi: "+855",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "COM",
		ddi: "+269",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XX XX",
			regex: /^3\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "MMR",
		ddi: "+95",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "X XXX XXXXXX",
			regex: /^9\s\d{3}\s\d{6}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "CPV",
		ddi: "+238",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XX XX",
			regex: /^9\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "ARM",
		ddi: "+374",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^(9[0-9]|55|77)\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "BHS",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 242,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "GIB",
		ddi: "+350",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "GRL",
		ddi: "+299",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "FRO",
		ddi: "+298",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "FLK",
		ddi: "+500",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "DNK",
		ddi: "+45",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX XX",
			regex: /^[2-9]\d{1,}(?:\s\d{2}){3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "PYF",
		ddi: "+689",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "ECU",
		ddi: "+593",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^9\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "EST",
		ddi: "+372",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^5\d{3}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "FIN",
		ddi: "+358",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^4\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "GRC",
		ddi: "+30",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^69\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "GBR",
		ddi: "+44",
		img: BandeiraGBR,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXXXX",
			regex: /^7\d{3}\s\d{6}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "GGY",
		ddi: "+44",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXXXX",
			regex: /^(7781|7839)\s\d{6}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "JEY",
		ddi: "+44",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXXXX",
			regex: /^(7797|7829)\s\d{6}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "TLS",
		ddi: "+670",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^77\d{2}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "CIV",
		ddi: "+225",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX XX XX",
			regex: /^0\s\d{2}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 14,
		},
	},
	{
		prefix: "GNB",
		ddi: "+245",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^9\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "GAB",
		ddi: "+241",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX XX",
			regex: /^0[6-7]\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "GNQ",
		ddi: "+240",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^2\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "KEN",
		ddi: "+254",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^7\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "ERI",
		ddi: "+291",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XX",
			regex: /^7\d{1}\s\d{3}\s\d{2}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "ETH",
		ddi: "+251",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^9\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "GTM",
		ddi: "+502",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^5\d{3}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "GHA",
		ddi: "+233",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^[2|3|5]\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "GUY",
		ddi: "+592",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^6\d{2}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "HKG",
		ddi: "+852",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^([5-9]{4})\s([5-9]{4})$/,
			maxLength: 9,
		},
	},
	{
		prefix: "HUN",
		ddi: "+36",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^3\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "HTI",
		ddi: "+509",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX XX",
			regex: /^3\d{1}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "ISR",
		ddi: "+972",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^5\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "IRQ",
		ddi: "+964",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^7\d{2}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "ISL",
		ddi: "+354",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^6\d{2}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "KAZ",
		ddi: "+7",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "(XXX) XXX XXXX",
			regex: /^\(70\d{1}\)\s\d{3}\s\d{4}$/,
			maxLength: 14,
		},
	},
	{
		prefix: "DJI",
		ddi: "+253",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX XX",
			regex: /^77\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "GEO",
		ddi: "+995",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^5\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "GMB",
		ddi: "+220",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^[7-9]\d{2}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "SLV",
		ddi: "+503",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^7\d{3}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "LUX",
		ddi: "+352",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^6\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "NRU",
		ddi: "+674",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^5\d{2}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "MNE",
		ddi: "+382",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^06\d{1}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "MUS",
		ddi: "+230",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^5\d{3}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "LVA",
		ddi: "+371",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^2\d{1}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "MAR",
		ddi: "+212",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "X XX XX XX XX",
			regex: /^6\s\d{2}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 13,
		},
	},
	{
		prefix: "MAC",
		ddi: "+853",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^6\d{3}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "XKX",
		ddi: "+383",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^4\d{1}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "MKD",
		ddi: "+389",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^7\d{1}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "LIE",
		ddi: "+423",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^660\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "ANT",
		ddi: "+599",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^\d{4}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "MLI",
		ddi: "+223",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX XX",
			regex: /^6\d{1}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "PRK",
		ddi: "+850",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "MHL",
		ddi: "+692",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "MYT",
		ddi: "+262",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "FSM",
		ddi: "+691",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "NIU",
		ddi: "+683",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "NCL",
		ddi: "+687",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "KIR",
		ddi: "+686",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "LAO",
		ddi: "+856",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XXX XXX",
			regex: /^20\s\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 13,
		},
	},
	{
		prefix: "LBN",
		ddi: "+961",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^7\d{1}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "LTU",
		ddi: "+370",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXXX",
			regex: /^6\d{2}\s\d{5}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "LBR",
		ddi: "+231",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^77\d{1}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "LSO",
		ddi: "+266",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^5\d{3}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "LBY",
		ddi: "+218",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^9\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "MDA",
		ddi: "+373",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXXX",
			regex: /^[6-7]\d{2}\s\d{5}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "MNG",
		ddi: "+976",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^8\d{3}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "MOZ",
		ddi: "+258",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^8\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "MWI",
		ddi: "+265",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^9\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "MDV",
		ddi: "+960",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^7\d{2}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "NAM",
		ddi: "+264",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^8\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "MRT",
		ddi: "+222",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX XX",
			regex: /^2\d{1}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "NGA",
		ddi: "+234",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^[7-9]\d{2}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "NPL",
		ddi: "+977",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXXX XXXX",
			regex: /^98\s\d{4}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "KWT",
		ddi: "+965",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^5\d{3}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "KGZ",
		ddi: "+996",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^[5|7|9]\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "PSE",
		ddi: "+970",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^5\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "ZAF",
		ddi: "+27",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^(6|7)\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "SXM",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 721,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "SWZ",
		ddi: "+268",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^7\d{3}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "CZE",
		ddi: "+420",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^6\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "SVN",
		ddi: "+386",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "SSD",
		ddi: "+211",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^9\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "CXR",
		ddi: "+61",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "REU",
		ddi: "+262",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "SHN",
		ddi: "+290",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "SMR",
		ddi: "+378",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^66\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "MAF",
		ddi: "+590",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "KOR",
		ddi: "+82",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX-XXXX-XXXX",
			regex: /^1\d{1}-\d{4}-\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "SPM",
		ddi: "+508",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "NOR",
		ddi: "+47",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XX XXX",
			regex: /^\d{3}\s\d{2}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "STP",
		ddi: "+239",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "POL",
		ddi: "+48",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^5\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "SJM",
		ddi: "+47",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "ROU",
		ddi: "+40",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^7\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "RUS",
		ddi: "+7",
		img: null,
		maxLength: 11,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "X (XXX) XXX-XX-XX",
			regex: /^8\s\(9\d{2}\)\s\d{3}-\d{2}-\d{2}$/,
			maxLength: 17,
		},
	},
	{
		prefix: "SYC",
		ddi: "+248",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^2\d{2}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "PLW",
		ddi: "+680",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^7\d{2}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "SEN",
		ddi: "+221",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^7[05678]\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "LCA",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 758,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "SRB",
		ddi: "+381",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^6[0-9]\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "VCT",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 784,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "SDN",
		ddi: "+249",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^9\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "SUR",
		ddi: "+597",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^7\d{2}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "QAT",
		ddi: "+974",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^3\d{3}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "RWA",
		ddi: "+250",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^7\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "OMN",
		ddi: "+968",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^9\d{3}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "SWE",
		ddi: "+46",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^7\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "SGP",
		ddi: "+65",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^[8|9]\d{3}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "WSM",
		ddi: "+685",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^7\d{2}\s\d{4}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "LKA",
		ddi: "+94",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^7\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "ZWE",
		ddi: "+263",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^7\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "TUV",
		ddi: "+688",
		img: null,
		maxLength: 6,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX",
			regex: /^9\d{2}\s\d{3}$/,
			maxLength: 7,
		},
	},
	{
		prefix: "GUM",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 671,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "MLT",
		ddi: "+356",
		img: BandeiraMLT,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX XX",
			regex: /^[7]\d{1}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "TWN",
		ddi: "+886",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^9\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "VNM",
		ddi: "+84",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^[35789]\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "VAT",
		ddi: "+379",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^3\d{2}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "WLF",
		ddi: "+681",
		img: null,
		maxLength: 6,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX",
			regex: /^5\d{1}\s\d{2}\s\d{2}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "NER",
		ddi: "+227",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX XX",
			regex: /^9\d{1}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "TGO",
		ddi: "+228",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX XX",
			regex: /^9\d{1}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "AIA",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 264,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "COG",
		ddi: "+242",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "COD",
		ddi: "+243",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "GNB",
		ddi: "+245",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^\d{3}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "IOT",
		ddi: "+246",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^\d{3}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "SYC",
		ddi: "+248",
		img: null,
		maxLength: 7,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX",
			regex: /^\d{3}\s\d{4}$/,
			maxLength: 8,
		},
	},
	{
		prefix: "TKL",
		ddi: "+690",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "TZA",
		ddi: "+255",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^[6|7]\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "THA",
		ddi: "+66",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^[689]\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "TKM",
		ddi: "+993",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXXXXX",
			regex: /^6\d{1}\s\d{6}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "TJK",
		ddi: "+992",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^9\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "UKR",
		ddi: "+380",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^63\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "TZA",
		ddi: "+255",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^[6|7]\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "MOZ",
		ddi: "+258",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "NAM",
		ddi: "+264",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "MWI",
		ddi: "+265",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "LSO",
		ddi: "+266",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "BWA",
		ddi: "+267",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "ZMB",
		ddi: "+260",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^9[5-9]\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "AFG",
		ddi: "+93",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^7\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "CHE",
		ddi: "+41",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XX XX",
			regex: /^7\d{1}\s\d{3}\s\d{2}\s\d{2}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "IDN",
		ddi: "+62",
		img: null,
		maxLength: 11,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX XXXX",
			regex: /^8\d{2}\s\d{4}\s\d{4}$/,
			maxLength: 13,
		},
	},
	{
		prefix: "IMN",
		ddi: "+44",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXXXX",
			regex: /^7624\s\d{6}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "SLE",
		ddi: "+232",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXX",
			regex: /^7[5-9]\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "SYR",
		ddi: "+963",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^9\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "GIN",
		ddi: "+224",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XX XXX",
			regex: /^6\d{2}\s\d{2}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "JPN",
		ddi: "+81",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^(70|80|90)\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "MDG",
		ddi: "+261",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XXX XX",
			regex: /^3\d{1}\s\d{2}\s\d{3}\s\d{2}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "MCO",
		ddi: "+377",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XX XX XX XX",
			regex: /^06\s\d{2}\s\d{2}\s\d{2}\s\d{2}$/,
			maxLength: 14,
		},
	},
	{
		prefix: "SOM",
		ddi: "+252",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^6\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "TUR",
		ddi: "+90",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^5\d{2}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "SVK",
		ddi: "+421",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^9\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "IRN",
		ddi: "+98",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^9\d{2}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "ESH",
		ddi: "+212",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^6\d{2}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "YEM",
		ddi: "+967",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^7\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "MSR",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 664,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "KNA",
		ddi: "+1",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 869,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "COD",
		ddi: "+243",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "BLM",
		ddi: "+590",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "IOT",
		ddi: "+246",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXXXXXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "IRL",
		ddi: "+353",
		img: BandeiraIRL,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^\d{2}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "IND",
		ddi: "+91",
		img: BandeiraIND,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXXX-XXXXX",
			regex: /^\d{5}-\d{5}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "NZL",
		ddi: "+64",
		img: BandeiraNZL,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX XXXX",
			regex: /^\d{2}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "COL",
		ddi: "+57",
		img: BandeiraCOL,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "PHL",
		ddi: "+63",
		img: BandeiraPHL,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "USA",
		ddi: "+1",
		img: BandeiraEUA,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: false,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "(XXX) XXX-XXXX",
			regex: /^\(\d{3}\)\s\d{3}-\d{4}$/,
			maxLength: 14,
		},
	},
	{
		prefix: "CAN",
		ddi: "+1",
		img: BandeiraCAN,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: false,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "(XXX) XXX-XXXX",
			regex: /^\(\d{3}\)\s\d{3}-\d{4}$/,
			maxLength: 14,
		},
	},
	{
		prefix: "BGD",
		ddi: "+880",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX-XXXXXX",
			regex: /^1\d{3}\s\d{6}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "EGY",
		ddi: "+20",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^1\d{2}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "HND",
		ddi: "+504",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^9\d{3}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "JOR",
		ddi: "+962",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^79\d{1}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "MYS",
		ddi: "+60",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX-XXXXXXX",
			regex: /^1\d{1}-\d{7}$/,
			maxLength: 10,
		},
	},
	{
		prefix: "NIC",
		ddi: "+505",
		img: null,
		maxLength: 8,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXXX XXXX",
			regex: /^8\d{3}\s\d{4}$/,
			maxLength: 9,
		},
	},
	{
		prefix: "PAK",
		ddi: "+92",
		img: null,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXXXXX",
			regex: /^3\d{2}\s\d{7}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "SAU",
		ddi: "+966",
		img: null,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XX XXX XXXX",
			regex: /^5\d{1}\s\d{3}\s\d{4}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "MEX",
		ddi: "+52",
		img: BandeiraMEX,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "(XXX) XXX-XXXX",
			regex: /^\(\d{3}\)\s\d{3}-\d{4}$/,
			maxLength: 14,
		},
	},
	{
		prefix: "AUS",
		ddi: "+61",
		img: BandeiraAUS,
		maxLength: 9,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXX XXX",
			regex: /^\d{3}\s\d{3}\s\d{3}$/,
			maxLength: 11,
		},
	},
	{
		prefix: "BMU",
		ddi: "+1",
		img: BandeiraBMU,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: 441,
		phonePositionNumberExtraPrefix: 0,
		pattern: {
			mask: "XXX XXX XXXX",
			regex: /^\d{3}\s\d{3}\s\d{4}$/,
			maxLength: 12,
		},
	},
	{
		prefix: "CHN",
		ddi: "+86",
		img: BandeiraCHN,
		maxLength: 11,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXX XXXX",
			regex: /^\d{3}\s\d{4}\s\d{4}$/,
			maxLength: 13,
		},
	},
	{
		prefix: "DEU",
		ddi: "+49",
		img: BandeiraALE,
		maxLength: 10,
		phoneTypeAuthVerify: "sms",
		removePrefix: true,
		phoneExtraPrefixNumber: null,
		phonePositionNumberExtraPrefix: null,
		pattern: {
			mask: "XXX XXXXXXX",
			regex: /^\d{3}\s\d{7}$/,
			maxLength: 11,
		},
	},
];

// Mapeamento de países do countriesHelper para códigos ISO do react-phone-input-2
const countryCodeMapping = {
	// América do Norte
	"USA": "us",
	"CAN": "ca",
	
	// América Central e Caribe
	"MEX": "mx",
	"DMA": "dm",
	"GRD": "gd",
	"CUB": "cu",
	"JAM": "jm",
	"DOM": "do",
	"CRI": "cr",
	"PAN": "pa",
	"BLZ": "bz",
	"ATG": "ag",
	"GTM": "gt",
	"SLV": "sv",
	"HND": "hn",
	"NIC": "ni",
	"TCA": "tc",
	"AIA": "ai",
	"VGB": "vg",
	"BRB": "bb",
	"KNA": "kn",
	"LCA": "lc",
	"VCT": "vc",
	"ABW": "aw",
	"CUW": "cw",
	"SXM": "sx",
	"BMU": "bm",
	"BHS": "bs",
	"TTO": "tt",
	
	// América do Sul
	"BRA": "br",
	"ARG": "ar",
	"CHL": "cl",
	"COL": "co",
	"PER": "pe",
	"URY": "uy",
	"PAR": "py",
	"VEN": "ve",
	"BOL": "bo",
	"GUY": "gy",
	"SUR": "sr",
	"ECU": "ec",
	
	// Europa
	"ESP": "es",
	"POR": "pt",
	"FRA": "fr",
	"ALE": "de",
	"ITA": "it",
	"GBR": "gb",
	"IRL": "ie",
	"BEL": "be",
	"NLD": "nl",
	"AUT": "at",
	"CHE": "ch",
	"SWE": "se",
	"NOR": "no",
	"DNK": "dk",
	"FIN": "fi",
	"POL": "pl",
	"CZE": "cz",
	"HUN": "hu",
	"ROU": "ro",
	"BGR": "bg",
	"GRC": "gr",
	"CYP": "cy",
	"MLT": "mt",
	"HRV": "hr",
	"SVN": "si",
	"SVK": "sk",
	"LTU": "lt",
	"LVA": "lv",
	"EST": "ee",
	"RUS": "ru",
	"UKR": "ua",
	"BLR": "by",
	"MDA": "md",
	"ALB": "al",
	"BIH": "ba",
	"SRB": "rs",
	"MNE": "me",
	"MKD": "mk",
	"TUR": "tr",
	"GEO": "ge",
	"ARM": "am",
	"AZE": "az",
	"LUX": "lu",
	"LIE": "li",
	"MON": "mc",
	"AND": "ad",
	"SMR": "sm",
	"VAT": "va",
	"ISL": "is",
	"FRO": "fo",
	"GRL": "gl",
	"GIB": "gi",
	"JEY": "je",
	"GGY": "gg",
	"IOM": "im",
	
	// Ásia
	"CHN": "cn",
	"JPN": "jp",
	"KOR": "kr",
	"PRK": "kp",
	"MNG": "mn",
	"TWN": "tw",
	"HKG": "hk",
	"MAC": "mo",
	"IND": "in",
	"PAK": "pk",
	"BGD": "bd",
	"LKA": "lk",
	"MDV": "mv",
	"NPL": "np",
	"BTN": "bt",
	"MMR": "mm",
	"THA": "th",
	"LAO": "la",
	"KHM": "kh",
	"VNM": "vn",
	"MYS": "my",
	"SGP": "sg",
	"IDN": "id",
	"PHL": "ph",
	"BRN": "bn",
	"TLS": "tl",
	"KAZ": "kz",
	"UZB": "uz",
	"KGZ": "kg",
	"TJK": "tj",
	"TKM": "tm",
	"AFG": "af",
	"IRN": "ir",
	"IRQ": "iq",
	"SYR": "sy",
	"LBN": "lb",
	"JOR": "jo",
	"ISR": "il",
	"PSE": "ps",
	"SAU": "sa",
	"YEM": "ye",
	"OMN": "om",
	"ARE": "ae",
	"QAT": "qa",
	"BHR": "bh",
	"KWT": "kw",
	"MDV": "mv",
	
	// África
	"ZAF": "za",
	"NGA": "ng",
	"EGY": "eg",
	"MAR": "ma",
	"TUN": "tn",
	"DZA": "dz",
	"LBY": "ly",
	"SDN": "sd",
	"SSD": "ss",
	"ETH": "et",
	"KEN": "ke",
	"UGA": "ug",
	"TZA": "tz",
	"RWA": "rw",
	"BDI": "bi",
	"DJI": "dj",
	"SOM": "so",
	"ERI": "er",
	"GHA": "gh",
	"CIV": "ci",
	"SEN": "sn",
	"MLI": "ml",
	"BFA": "bf",
	"NER": "ne",
	"TCD": "td",
	"CMR": "cm",
	"CAF": "cf",
	"COG": "cg",
	"COD": "cd",
	"AGO": "ao",
	"ZMB": "zm",
	"ZWE": "zw",
	"BWA": "bw",
	"NAM": "na",
	"SWZ": "sz",
	"LSO": "ls",
	"MDG": "mg",
	"MUS": "mu",
	"SYC": "sc",
	"COM": "km",
	"STP": "st",
	"GNQ": "gq",
	"CPV": "cv",
	"GMB": "gm",
	"GIN": "gn",
	"GNB": "gw",
	"SLE": "sl",
	"LBR": "lr",
	"BEN": "bj",
	"TGO": "tg",
	"GAB": "ga",
	
	// Oceania
	"AUS": "au",
	"NZL": "nz",
	"FJI": "fj",
	"PNG": "pg",
	"SLB": "sb",
	"VUT": "vu",
	"NCL": "nc",
	"PYF": "pf",
	"TON": "to",
	"WSM": "ws",
	"KIR": "ki",
	"TUV": "tv",
	"NRU": "nr",
	"PLW": "pw",
	"FSM": "fm",
	"MHL": "mh",
	"COK": "ck",
	"ASM": "as",
	"GUM": "gu",
	"MP": "mp",
	"PR": "pr",
	"VI": "vi"
};

// Função para obter todos os países disponíveis para react-phone-input-2
export const getAvailableCountries = () => {
	const countries = [];
	const addedCountries = new Set();
	
	ddis.forEach(country => {
		const isoCode = countryCodeMapping[country.prefix];
		if (isoCode && !addedCountries.has(isoCode)) {
			countries.push(isoCode);
			addedCountries.add(isoCode);
		}
	});
	
	return countries.sort();
};

// Função para obter código ISO de um país pelo prefixo
export const getCountryCode = (prefix) => {
	return countryCodeMapping[prefix] || null;
};

export default ddis;
